import tribunalAPI from "../../api/tribunalAPi";


export const getLstCursos = async (cveUsuario: number | null) => {
    let url = `/cursos/getCursosVigentes?cveUsuario= ${cveUsuario}`;
    return await tribunalAPI.post(url);
};

export const getCursoViente = async (cveUsuario: number | null) => {
    let url = `/cursos/getCursoVigente?cveUsuario=${cveUsuario}`;
    return await tribunalAPI.post(url);
};

export const postCursoInscripcion = async (data: any) => {
    let url = "/cursos/inscripcion";
    return await tribunalAPI.post(url, data);
};

export const postConfirmarInscripcion = async (data: any) => {
    let url = "/cursos/inscripcion/confirmar";
    return await tribunalAPI.post(url, data);
};
